import * as React from 'react';

import {useGetCalendars} from '../graphql/hooks';

import {getSelectedCalendarId} from './helpers';
import {SelectCalendarModal} from './select-calendar-modal';

type Props = {
    username: string;
    isOpen: boolean;
    onClose: () => void;
    onSave: (calendarId: string) => Promise<any>;
    modalType: 'conflict' | 'sync';
    isEmbedded?: boolean;
};

export function SelectCalendarModalWrapper(props: Props) {
    const [isSelectingCalendar, setIsSelectingCalendar] = React.useState(false);
    const {calendars, isLoading} = useGetCalendars(props.username);

    if (calendars.length === 0 || isLoading) {
        return null;
    }

    return (
        <SelectCalendarModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            calendars={calendars}
            isAddingCalendar={isSelectingCalendar}
            modalType={props.modalType}
            onSave={(calendarId) => {
                setIsSelectingCalendar(true);
                props.onSave(calendarId).then(() => {
                    setIsSelectingCalendar(false);
                });
            }}
            currentSelectionId={getSelectedCalendarId(calendars, props.modalType)}
            isEmbedded={props.isEmbedded}
        />
    );
}
